import { render } from "./IntegracionRegional.vue?vue&type=template&id=1aa2b75f&scoped=true"
import script from "./IntegracionRegional.vue?vue&type=script&lang=js"
export * from "./IntegracionRegional.vue?vue&type=script&lang=js"

import "./IntegracionRegional.vue?vue&type=style&index=0&id=1aa2b75f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa2b75f"]])

export default __exports__